<template>
    <!-- 文字连接组件 -->
    <el-link 
    :type="type"
    :underline="underline"
    :disabled="disabled	"
    :href="href" 
    :icon="icon"
    :target="target">
        {{linkText}}
        <slot></slot>
    </el-link>
</template>
<script>
export default {
    name:"VelLink",
    props:{
        type:{
            type: String,
            default:'primary',
        },
        isUnderline:Boolean,
        isDisable:Boolean,
        href:String,
        icon:String,
        target:{
            type: String,
            default: '_blank'
        },
        linkText:{
            type: String,
            default: 'link'
        }
    },
    data() {
        return {
            disabled:false,
            underline:true,
        };
    },
    created(){
        this.initDateFn()
    },
    methods:{
        initDateFn(){
            this.isUnderline ? this.underline = false : this.underline
            this.isDisable ? this.disabled = true : this.disabled
        }
    }
}
</script>